"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var decentraland_ui_1 = require("decentraland-ui");

var utils_1 = require("../../modules/translation/utils");

var TranslationProvider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TranslationProvider, _React$PureComponent);

  function TranslationProvider() {
    _classCallCheck(this, TranslationProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(TranslationProvider).apply(this, arguments));
  }

  _createClass(TranslationProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          locale = _this$props.locale,
          onFetchTranslations = _this$props.onFetchTranslations;

      if (locale && prevProps.locale !== locale) {
        onFetchTranslations(locale);
      }
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return React.createElement(decentraland_ui_1.Loader, {
        active: true,
        size: "massive"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          locale = _this$props2.locale,
          translations = _this$props2.translations;
      return translations && locale ? React.createElement(utils_1.I18nProvider, {
        key: locale,
        locale: locale,
        messages: translations
      }, children) : this.renderLoading();
    }
  }]);

  return TranslationProvider;
}(React.PureComponent);

exports.default = TranslationProvider;